import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import { Stack, Avatar, Button } from "@mui/material";
import Label from "src/components/Label";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import { s3baseUrl } from "src/config/config";
import { deleteWorkouteApi, list_workout_api } from "src/DAL/workout/workout";
import moment from "moment";
import { getValidMealArray, show_proper_words } from "src/utils/constant";
import CustomMUITable from "src/components/CustomMUITable";
import GeneralFilter from "./GeneralFilter";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import FilteredChipNew from "src/components/FilteredChipNew";
import WorkoutAssign from "./WorkoutAssign";
import MealAccordion from "../FoodMattersLibrary/MealAccordion";
import CustomPopoverNew from "src/components/CustomPopoverNew";
import { AllActiveWorkoutTypeListingApi } from "src/DAL/workoutType/workoutType";
import AddOrUpdateModelLibrary from "./AddOrUpdateModelLibrary";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const EMPTY_FILTER = {
  check_status: "",
  workout_type: null,
  search: "",
};

const tabs = {
  asc: "asc",
  desc: "desc",
};

export default function GeneralListing({ type }) {
  const prevTypeRef = useRef(type);
  const navigate = useNavigate();
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(tabs.asc);
  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [workout, setWorkout] = useState([]);
  const [openAssign, setOpenAssign] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isMealData, setIsMealData] = useState(null);
  const [openFor, setOpenFor] = useState("Add");
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [editData, setEditData] = useState(null);
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [updateFilterData, setUpdateFilterData] = useState(EMPTY_FILTER);
  const [modalData, setModalData] = useState(null);
  const [workoutType, setWorkoutType] = useState([]);

  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  const getWorkoutList = async (filterData) => {
    let postData = {
      workout_type: filterData?.workout_type?._id || "",
      status: filterData?.check_status || "",
      practice_type: type,
      sort: selectedTab,
      search: filterData?.search || "",
    };
    setIsLoading(true);
    handleCloseFilterDrawer();
    let result = await list_workout_api(page, rowsPerPage, postData);
    if (result.code == 200) {
      let chipData = { ...filterData };
      delete chipData.search;
      if (filterData?.workout_type) {
        chipData.workout_type = {
          ...filterData?.workout_type,
          chip_value: filterData?.workout_type?._id,
          chip_label: filterData?.workout_type?.title,
        };
      }

      setUpdateFilterData(chipData);
      let data = result?.workouts.map((item) => {
        let type_name = "N/A";

        if (type === "workbook") {
          type_name =
            item?.library_type === "workout-type"
              ? "Wookbook"
              : item?.library_type === "meal-type"
              ? "Nutrition"
              : "Mindset";
        } else {
          type_name = item?.type_info?.title;
        }

        return {
          ...item,
          type_name: type_name,
          date: moment(item?.createdAt).format("DD-MM-YYYY"),
        };
      });
      setWorkout(data);
      setTotalCount(result.total_workouts);
      setTotalPages(result.total_pages);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const getWorkoutTypes = async () => {
    const result = await AllActiveWorkoutTypeListingApi(type);
    if (result.code === 200) {
      setWorkoutType(result?.workout_types);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleClearFilter = () => {
    setPage(0);
    setPageCount(1);
    setFilterData(EMPTY_FILTER);
    setUpdateFilterData(EMPTY_FILTER);
    getWorkoutList(EMPTY_FILTER);
    localStorage.removeItem(`${type}_library_filter`);
  };

  const handleDeleteChip = (data) => {
    setPage(0);
    setPageCount(1);
    localStorage.setItem(`${type}_library_filter`, JSON.stringify(data));
    setFilterData(data);
    setUpdateFilterData(data);
    getWorkoutList(data);
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  const handleEdit = (value) => {
    setOpenFor("Edit");
    setEditData(value);
    setModalOpen(true);
  };

  const handleEditWorkout = (value) => {
    if (type === "video") {
      navigate(`/videoset-edit/${value?.workout_slug}`, {
        state: value,
      });
    } else if (type === "comment") {
      navigate(`/commentset-edit/${value?.workout_slug}`, {
        state: value,
      });
    } else if (type === "workbook") {
      navigate(`/workbook-edit/${value?.workout_slug}`, {
        state: value,
      });
    } else if (type === "mindset") {
      navigate(`/mindset-edit/${value?.workout_slug}`, {
        state: value,
      });
    } else if (type === "food") {
      navigate(`/food_matters-edit/${value?.workout_slug}`, {
        state: value,
      });
    } else {
      navigate(`/workout-edit/${value?.workout_slug}`, {
        state: value,
      });
    }
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleAssignMember = (value) => {
    setModalData(value);
    setOpenAssign(true);
  };

  const handleNavigatePreview = (value) => {
    setIsMealData(getValidMealArray(value.meals));
    setIsOpenModal(true);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    const result = await deleteWorkouteApi(deleteDoc.workout_slug);
    if (result.code === 200) {
      setWorkout((old) =>
        old.filter((item) => item.workout_slug !== deleteDoc.workout_slug),
      );
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    filterData.search = searchText;
    localStorage.setItem(`${type}_library_filter`, JSON.stringify(filterData));
    getWorkoutList(filterData);
  };

  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    const typeChanged = prevTypeRef.current !== type;
    prevTypeRef.current = type;

    let filter_data = { ...EMPTY_FILTER };
    const find_filter = localStorage.getItem(`${type}_library_filter`);

    if (find_filter) {
      filter_data = JSON.parse(find_filter);

      if (typeChanged) {
        delete filter_data.search;
      }
    }
    setSearchText(typeChanged ? "" : filter_data?.search);

    setFilterData(filter_data);
    setUpdateFilterData(filter_data);
    getWorkoutList(filter_data);
  }, [page, rowsPerPage, selectedTab, type]);

  useEffect(() => {
    if (modalOpen) {
      getWorkoutTypes();
    }
  }, [modalOpen, type]);

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },
    {
      label: `Edit ${show_proper_words(type === "nutrition" ? "Meal" : type)}`,
      icon: "akar-icons:edit",
      handleClick: handleEditWorkout,
    },
    {
      label: `Assign ${show_proper_words(
        type === "food" ? "Meal Plan" : type,
      )}`,
      icon: "eva:bar-chart-fill",
      handleClick: handleAssignMember,
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];

  const TABLE_HEAD = [
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: "MENU_OPTIONS",
    },
    { id: "number", label: "#", type: "number" },
    {
      id: "title",
      label: "Name",
      renderData: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing={2}>
            <div>
              <Avatar
                variant="rounded"
                sx={{ height: 60, width: 60 }}
                src={s3baseUrl + row?.image?.thumbnail_1}
                alt={Capitalize(row.title)}
              />
            </div>
            <div style={{ fontSize: 11 }}>
              <h6 className="h2-heading ">{Capitalize(row?.title)}</h6>
              {Capitalize(htmlDecode(row?.description)).substring(0, 250) +
                "..."}
            </div>
          </Stack>
        );
      },
    },
    {
      id: "type_name",
      label: `${show_proper_words(type === "food" ? "Diet" : type)} Type`,
    },
    type === "food" && {
      id: "preview",
      label: "Preview",
      renderData: (row) => {
        return (
          <a
            className="anchor-style"
            onClick={() => handleNavigatePreview(row)}
          >
            Preview
          </a>
        );
      },
    },
    { id: "date", label: "Created At" },
    { id: "status", label: "Status", type: "row_status" },
  ];

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <h2>
              {type === "food" ? "Daily Meal Plan" : show_proper_words(type)}
            </h2>
          </div>
          <div className="col-lg-4 col-sm-12 text-end">
            <button
              className="small-contained-button me-2"
              variant="contained"
              onClick={handleOpenFilterDrawer}
            >
              Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
            </button>
            <AddOrUpdateModelLibrary
              open={modalOpen}
              setOpen={setModalOpen}
              workoutTypes={workoutType}
              openFor={openFor}
              data={editData}
              setOpenFor={setOpenFor}
              searchFunction={searchFunction}
              type={type}
            />
          </div>
        </div>
        <div className="my-3">
          <FilteredChipNew
            data={updateFilterData}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onDeleteChip={handleDeleteChip}
            onClear={handleClearFilter}
          />
        </div>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={3}
          mb={1}
        >
          <div className="d-flex">
            <div className="me-2 pointer">
              <Label
                onClick={() => {
                  setPage(0);
                  setPageCount(1);
                  setSelectedTab(tabs.asc);
                }}
                variant={selectedTab === tabs.asc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                A-Z
              </Label>
            </div>
            <div className="me-2 pointer">
              <Label
                onClick={() => {
                  setPage(0);
                  setPageCount(1);
                  setSelectedTab(tabs.desc);
                }}
                variant={selectedTab === tabs.desc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                Z-A
              </Label>
            </div>
          </div>
        </Stack>
        <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          MENU_OPTIONS={MENU_OPTIONS}
          data={workout}
          className="card-with-background"
          custom_pagination={{
            total_count: totalCount,
            rows_per_page: rowsPerPage,
            page: page,
            handleChangePage: handleChangePage,
            onRowsPerPageChange: handleChangeRowsPerPage,
          }}
          custom_search={{
            searchText: searchText,
            setSearchText: setSearchText,
            handleSubmit: searchFunction,
          }}
          pageCount={pageCount}
          totalPages={totalPages}
          handleChangePages={handleChangePages}
          pagePagination={true}
          rows_per_page_count={rowsPerPage}
        />
        <CustomDrawer
          isOpenDrawer={filterDrawerState}
          onOpenDrawer={handleOpenFilterDrawer}
          onCloseDrawer={handleCloseFilterDrawer}
          pageTitle="Filters"
          componentToPassDown={
            <GeneralFilter
              filterData={filterData}
              setFilterData={setFilterData}
              searchSubmitFilter={searchFunction}
              handleClearFilter={handleClearFilter}
              type={type}
            />
          }
        />
        {openAssign && (
          <WorkoutAssign
            open={openAssign}
            setOpen={setOpenAssign}
            data={modalData}
          />
        )}

        {isOpenModal && (
          <CustomPopoverNew
            isOpenPop={isOpenModal}
            isClosePop={setIsOpenModal}
            title={`${show_proper_words(
              type === "food" ? "Meal Plan" : type,
            )} Detail`}
            componentToPassDown={<MealAccordion isMealData={isMealData} />}
          />
        )}
      </div>
    </>
  );
}
